import React, { useState } from "react";
import { CircularProgress, Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import LinkBox from "../../../components/Content/LinkBox";
import ContentCard from "../../../components/Content/ContentCard/index";
import FinalEssayModal from "../../../components/Modals/FinalEssayModal";
import MonasteryProgressModal from "../../../components/Modals/MonasteryProgressModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { monasteryData } from "../../../assets/data/data";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  LINK_BOX_TITLE,
  LINK_BOX_LINK,
  SECTION_CERTIFICATION,
  CERTIFICATION_HTML,
  SECTION_DASHBOARD,
  FOOTER_TEXT,
  SUCCESS_MESSAGE,
} from "./Monastery.constants";
import { FooterText } from "../../../components/Common/FooterText";
import {
  RootBox,
  StyledBackdrop,
  ContentBox,
  SectionHeading,
  BodyText,
  CardsGrid,
} from "./Monastery.styles";

const Monastery = () => {
  const [essayModalState, setEssayModalState] = useState(false);
  const [monasteryProgressState, setMonasteryProgressState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleCardClick = (item) => {
    if (item.modal === "essay") {
      setEssayModalState(true);
    } else if (item.modal === "progress") {
      setMonasteryProgressState(true);
    } else if (item.link) {
      window.open(item.link, "_blank");
    }
  };

  return (
    <RootBox>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message ?? errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={SUCCESS_MESSAGE}
      />

      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <ContentBox>
        <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_LINK} />

        <SectionHeading>{SECTION_CERTIFICATION}</SectionHeading>
        <BodyText dangerouslySetInnerHTML={{ __html: CERTIFICATION_HTML }} />

        <SectionHeading>{SECTION_DASHBOARD}</SectionHeading>

        <CardsGrid container spacing={2}>
          {monasteryData.map((item) => (
            <Grid2 item size={{ xs: 12, md: 6 }} key={item.id}>
              <ContentCard
                item={item}
                height="150px"
                clickable={item.type === "clickable"}
                onClick={() => handleCardClick(item)}
              />
            </Grid2>
          ))}
        </CardsGrid>
      </ContentBox>

      <FooterText>{FOOTER_TEXT}</FooterText>

      <FinalEssayModal
        open={essayModalState}
        handleClose={() => setEssayModalState(false)}
        setErrorState={setErrorState}
        setLoading={setLoading}
        setSuccess={setSuccess}
      />
      <MonasteryProgressModal
        open={monasteryProgressState}
        handleClose={() => setMonasteryProgressState(false)}
        setErrorState={setErrorState}
        setLoading={setLoading}
        setSuccess={setSuccess}
      />
    </RootBox>
  );
};

export default Monastery;
